<template>
  <svg width="100%" height="100%" id="pressureFlowChart" ref="pressureFlowChart">
    <Grid/>
    <XAxis/>
    <Points
      v-if="validInputs"
      :data="getSegments"
      :type="'pressure'"
    />
    <Points
      v-if="validInputs"
      :data="getSegments"
      :type="'flow'"
    />
    <RangeMarker
      v-if="showPressureMarkers"
      v-for="marker, index in pressureMarkers"
      :color="pressureColor"
      :type="'pressure'"
      :value="marker"
      :num="index"
    />
    <RangeMarker
      v-if="showFlowMarkers"
      v-for="marker, index in flowMarkers"
      :color="flowColor"
      :type="'flow'"
      :value="marker"
      :num="index"
    />
    <PipeLines/>
    <OffsetSlider type="left" />
    <OffsetSlider type="right" />
  </svg>
</template>

<script>
import { useInputStore } from '@/store/InputStore.js';
import { usePipeStore } from '@/store/PipeStore';
import { usePrintStore } from '@/store/PrintStore';
import { useSegmentStore } from '@/store/SegmentStore';
import { useSettingsStore } from '@/store/SettingsStore';
import Grid from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/Grid.vue';
import NumericField from '@/components/nelson/NumericField.vue';
import OffsetSlider from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/OffsetSlider.vue';
import PipeLines from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/PipeLines';
import Points from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/Points.vue';
import RangeMarker from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/RangeMarker.vue';
import XAxis from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/XAxis.vue';
import YAxisLines from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/YAxisLines';
import * as UnitConversion from '@/services/UnitConversionService';

export default {
  name: 'PressureFlowChart',
  components: {
    NumericField,
    PipeLines,
    Grid,
    OffsetSlider,
    Points,
    RangeMarker,
    XAxis,
    YAxisLines
  },
  data ()  {
    return {
      resizeObserver: null,
      printIsOpen: false,
    };
  },
  mounted () {
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(document.getElementById('pressureFlowChart'));
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  unmounted () {
    this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.handleResize);
  },
  watch : {
    pipes: {
      handler () {
      //  this.handleResize();
      },
      deep: false
    },
    printCancel: {
      handler (to) {
        this.handleResize();
        if (to) {

          this.printIsOpen = true;
        }
      }
    }
  },
  props: [
    'isPrint'
  ],
  computed: {
    validInputs () {
      return useInputStore().validInputs;
    },
    pipes () {
      return usePipeStore().getPipes;
    },
    printCancel () {
      return usePrintStore().getPrintIsOpen;
    },
    getYOffset () {
      return -25;
    },
    getOffsetLTransform () {
      return 'transform:translate(' + parseInt((useInputStore().getLeftOffset * this.getMagScale) + 36) + 'px, ' + this.getYOffset + 'px);';
    },
    getOffsetRTransform () {
      return 'transform:translate(' + parseInt((useSegmentStore().getAllSegmentLengths('pipe') * this.getMagScale) - (useInputStore().getRightOffset * this.getMagScale) - 125) + 'px, ' + this.getYOffset + 'px);';
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    flowColor () {
      return 'var(--flow-color);';
    },
    flowMarkers () {
      const sprinklerFlow = useSettingsStore().getSprinklerFlow;
      return [sprinklerFlow.min, sprinklerFlow.max].map((flow) => UnitConversion.FilterEmitterFlow(flow, useSettingsStore().getFlowUnit));
    },
    pressureColor () {
      return 'var(--pressure-color);';
    },
    pressureMarkers () {
      const sprinklerPressure = useSettingsStore().getSprinklerPressure;
      return [sprinklerPressure.min, sprinklerPressure.max].map((pressure) => UnitConversion.FilterPressure(pressure, useSettingsStore().getPressureUnit));
    },
    getSegments () {
      const calculatedSegments = useInputStore().getSegments;
      if (calculatedSegments.length > 0) {
        return calculatedSegments;
      } else {
        return [];
      }
    },
    showPressureMarkers () {
      return useSettingsStore().getSprinklerPressureVisibility;
    },
    showFlowMarkers () {
      return useSettingsStore().getSprinklerFlowVisibility;
    }
  },
  methods: {
    handleResize () {
      const inputStore = useInputStore();
      if ((usePrintStore().getPrintIsOpen && this.isPrint) || (this.$refs.pressureFlowChart !== null && !usePrintStore().getPrintIsOpen)) {
        inputStore.setPressureFlowChartHeight(this.$refs.pressureFlowChart.clientHeight);
        inputStore.setPressureFlowChartWidth(this.$refs.pressureFlowChart.clientWidth);
      }
    },
  },
};
</script>

<style scoped>
.debug {
  width: 20px;
  height: 20px;
  background-color: red;
  border-radius: 20px;
  position: absolute;
}
.offset-field-l {
  position: absolute;
}
.offset-field-r {
  position: absolute;
}
</style>